import React from "react";
import { Badge } from "antd";

interface Props {
  count: number;
}

const TaxonomicChangeBadge = ({ count }: Props) => {
  if (!count || count <= 0) return null;

  return (
    <Badge
      count={count}
      size="small"
      style={{ backgroundColor: "#faad14", marginLeft: 6 }}
      title={`${count} pending taxonomic change${count > 1 ? "s" : ""}`}
    />
  );
};

export default TaxonomicChangeBadge;
